module.exports = __webpack_public_path__ + "img/cheveronDown.52864259.svg";